<template>
  <div class="mx-n2 position-relative searchable-list">
    <input
      ref="search"
      placeholder="Name or Email id"
      type="text"
      class="input-field short-gutters w-100"
      v-model="searchText"
      @keyup.enter="onEnterPress"
      @keyup.up="selectPreviousItem"
      @keyup.down="selectNextItem"
      @keyup="onKeyup"
      @focus="onSearchFocus"
      v-click-outside="onClickOutside"
      v-autofocus
      v-no-capture
    />
    <span class="close-icon" v-if="searchText" @click="searchText = null"></span>
    <div class="list-items menu-shadow" v-if="showList && searchText">
      <ul class="" ref="list">
        <li
          class="selectable"
          v-for="(option, index) in options"
          :key="index"
          :data-id="option.id"
          v-no-capture
        >
          <slot v-bind:option="option"> </slot>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ListNavigationMixin from '@/mixins/ListNavigationMixin'
import debounce from '@/utils/debounce'

export default {
  name: 'SearchableList',
  props: ['options'],
  mixins: [ListNavigationMixin],
  data() {
    return {
      searchText: null,
      showList: false
    }
  },
  methods: {
    onSearchFocus() {
      this.toggleList(true)
    },
    onClickOutside() {
      this.toggleList(false)
    },
    toggleList: debounce(function(show) {
      this.showList = show
    }, 200),
    onEnterPress() {
      this.searchText = ''
      this.emitSelected()
      this.toggleList(false)
    },
    onKeyup(event) {
      this.$emit('search', event.target.value)
      this.toggleList(true)
    }
  },
  watch: {
    showList(show) {
      if (!show) {
        this.searchText = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/forms';
@import '~@/styles/_styleConfigurations.scss';

.searchable-list {
}
.list-items {
  position: absolute;
  top: 110%;
  background-color: $documentColor;
  border-radius: 16px;
  width: 290px;
  max-height: 250px;
  overflow-y: auto;
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    li:first-child {
      margin-top: 10px;
    }
    li:last-child {
      margin-bottom: 10px;
    }
  }
  li {
    padding: 4px 20px;
  }

  li.selected {
    background-color: $quinary;
  }
}
.close-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  cursor: pointer;
  padding: 10px;
  background-position: 50%;
}
</style>
